export default __webpack_public_path__ + "static/media/VSB_CHL_IND_01.2c4d467f.jpg";